import { EmailAlt, Linkedin, Phone } from '@clearkit/icons';
import classnames from 'classnames';
import {
  CKContainerProps,
  CKIconBox,
  CKLayoutHorizontal,
  CKTooltip,
  cloneChildren,
} from 'clearkit';
import { AnchorHTMLAttributes } from 'react';

type TokenProps = CKContainerProps & {
  hasToken?: boolean;
  title?: React.ReactNode;
};

type TokenLinkProps = Omit<TokenProps, 'title'> &
  AnchorHTMLAttributes<HTMLAnchorElement>;

const TokenWrapper = ({ children, className, hasToken }: TokenProps) => (
  <CKIconBox as="span" className={classnames('text-gray-900 !p-2', className)}>
    {cloneChildren({
      children,
      newProps: {
        className: classnames('w-3 h-3', {
          'opacity-20': !hasToken,
        }),
      },
    })}
  </CKIconBox>
);

export const Token = ({ children, hasToken, title }: TokenProps) => {
  return hasToken ? (
    <CKTooltip targetClassName="flex" tooltip={title}>
      <TokenWrapper hasToken={hasToken}>{children}</TokenWrapper>
    </CKTooltip>
  ) : (
    <TokenWrapper hasToken={hasToken}>{children}</TokenWrapper>
  );
};

export const TokenLink = ({
  children,
  hasToken,
  href,
  ...rest
}: TokenLinkProps) => {
  return hasToken && href ? (
    <a
      {...rest}
      className="flex rounded outline-none ck-focus-ring"
      href={href}
    >
      <TokenWrapper
        className={classnames({
          '!text-blue-500': hasToken,
        })}
        hasToken={hasToken}
      >
        {children}
      </TokenWrapper>
    </a>
  ) : (
    <TokenWrapper>{children}</TokenWrapper>
  );
};

export const TokenGroup = ({
  children,
  className,
  ...rest
}: CKContainerProps) => (
  <CKLayoutHorizontal
    {...rest}
    className={classnames('h-full', className)}
    gap="0.5rem"
    justifyContent="start"
  >
    {children}
  </CKLayoutHorizontal>
);

type TokensProps = CKContainerProps & {
  hasTwitter?: boolean;
  hasLinkedIn?: boolean;
  hasPhone?: boolean;
  hasEmail?: boolean;
  isDealMaker?: boolean;
};

export const Tokens = ({
  className,
  hasEmail,
  hasLinkedIn,
  hasPhone,
  ...rest
}: TokensProps) => (
  <CKLayoutHorizontal
    {...rest}
    alignItems="center"
    className={classnames(
      'divide-x divide-gray-200 basis-auto shrink-0 grow min-h-[1.5rem]',
      className,
    )}
    gap="0.75rem"
    justifyContent="start"
  >
    <TokenGroup>
      {/* <Token hasToken={isDealMaker} title="Prospect is a deal maker">
        <Money
          className={classnames({
            'fill-gradient-br-green': isDealMaker,
          })}
        />
      </Token> */}
      <Token hasToken={hasLinkedIn} title="Prospect has LinkedIn">
        <Linkedin
          className={classnames({
            'text-linkedin': hasLinkedIn,
          })}
        />
      </Token>
      <Token hasToken={hasPhone} title="Prospect has a phone number">
        <Phone />
      </Token>
      <Token hasToken={hasEmail} title="Prospect has an email address">
        <EmailAlt />
      </Token>
    </TokenGroup>
  </CKLayoutHorizontal>
);
